export enum clientStorageDrivers {
    localStorage = 'localStorage',

    // If we need to use others in the future (such as IndexDB or Session storage add them below and add a driver)
}

export type StorageRecord = string | object | boolean | number;

export interface BellaClientStorageDriver {
    setItem: (key: string, value: string) => void;
    getItem: (key: string) => string;
    removeItem: (key: string) => void;
    clear: () => void;
}
